var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { enumNumericValues } from '@sonar-software/sonar-ts-lib';
import { noop } from 'lodash';
import { OptionFilter } from '@periscopes/general/filters';
import React from 'react';
import { COPY_GENERIC, COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { DATA_SENSITIVITY_LABELS, DataSensitivityLevelId } from '@sonar-software/sonar-core';
const options = enumNumericValues(DataSensitivityLevelId).map((level) => ({
    label: DATA_SENSITIVITY_LABELS[level],
    value: level
}));
export const DataSensitivityFormSelector = (_a) => {
    var { onChange = noop, placeholder } = _a, props = __rest(_a, ["onChange", "placeholder"]);
    return React.createElement(OptionFilter, Object.assign({}, props, { onChange: onChange, options: options, placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : COPY_GENERIC.SELECT(COPY_SPECIFIC.DATA_SENSITIVITY) }));
};
